import { breadcrumbsHeaderState } from '@approvalmax/ui/src/components';
import { useSetAtom } from 'jotai';
import { selectors } from 'modules/common';
import { domain, State } from 'modules/data';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { messages } from '../messages';
import { getRequest } from '../selectors/pageSelectors';

export const useBreadcrumbs = () => {
    const setBreadcrumbs = useSetAtom(breadcrumbsHeaderState);
    const request = useSelector((state: State) => getRequest(state));
    const workflowName =
        selectors.template.getTemplateDisplayNameByCode(request?.integrationCode) || request?.template.text;

    let name = messages.editRequestPageTitle({
        workflowName,
    });

    if (request?.statusV2 === domain.RequestStatusV2.Draft) {
        name = messages.createRequestPageTitle({
            workflowName,
        });
    }

    useEffect(() => {
        if (!request) return;

        setBreadcrumbs([
            {
                name,
            },
        ]);
    }, [name, request, setBreadcrumbs]);
};
